const getJsUTC = () => new Date().toISOString();

export default getJsUTC;
